import React from 'react';

import { RHFCombobox } from '@/Components/shadcn/rhf-combobox';
import { JobAdLanguage } from '@/Models/JobAdLanguage';
import { languages } from '@/Utils/JobAdLanguage/JobAdLanguages';
import UIStrings from '@/Utils/UIStrings';
import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';

interface JobDescriptionLanguageProps {
    disabled?: boolean;
}

function JobDescriptionLanguage({ disabled }: JobDescriptionLanguageProps): React.JSX.Element {
    return (
        <div className="flex min-w-0 flex-1 flex-col gap-2">
            <RHFCombobox<JobAdLanguage>
                name={JobDetailsFieldTypes.JobDescriptionLanguage}
                label={UIStrings.JobDescriptionLanguage}
                options={languages}
                disabled={disabled}
                fieldDataCy={JobDetailsFieldTypes.JobDescriptionLanguage}
            />
        </div>
    );
}

export default JobDescriptionLanguage;
